import { CollectionResource, LanguageModelResource } from '@/@core/models/api/resourcesResponse';
import { UploadConfigResponse } from '@/@core/models/api/uploadConfig';
import { ASSISTANT_SERVICE } from '@/@core/services/api/AssistantService';
import { t } from '@/i18n';
import { groupAndSortResources } from '@/modules/Resources/utils/groupAndSortResources';
import { createStoreId } from '@/stores/createStoreId';
import { useNotificationStore } from '@/stores/useNotificationStore';
import { useUserStore } from '@/stores/userStore';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useQaResourcesStore = defineStore(
  createStoreId('qaResources'),
  () => {
    const notificationStore = useNotificationStore();
    const userStore = useUserStore();

    const uploadConfig = ref<UploadConfigResponse | undefined>(undefined);
    const collectionResources = ref<CollectionResource[] | undefined>(undefined);
    const languageModelResources = ref<LanguageModelResource[] | undefined>(undefined);
    const qaResourcesUnavailable = ref(false);

    const getUploadConfig = async () => {
      if (userStore.userId != null) {
        uploadConfig.value = await ASSISTANT_SERVICE.qaUploadConfig(userStore.userId);
      }
    };

    const getQaResources = async () => {
      try {
        qaResourcesUnavailable.value = false;
        const resources = await ASSISTANT_SERVICE.qaResources();
        const resourcesGroupedAndSorted = groupAndSortResources(resources);
        collectionResources.value = resourcesGroupedAndSorted.Collection ?? [];
        languageModelResources.value = resourcesGroupedAndSorted.LanguageModel ?? [];
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-ignored-exceptions
      } catch (error) {
        // TODO: differentiate error types (AST-664)
        notificationStore.addErrorNotification(t('QA_NOTIFICATIONS.load-collections-failed'));
        collectionResources.value = undefined;
        languageModelResources.value = undefined;
        qaResourcesUnavailable.value = true;
      }
    };

    return {
      uploadConfig,
      collectionResources,
      languageModelResources,
      qaResourcesUnavailable,
      getUploadConfig,
      getQaResources,
    };
  },
  {
    persist: true,
  }
);
